export default __webpack_public_path__ + "static/media/DNo.22-2.4c4d63f8.jpg";